import React from "react";
import {
  breakpointClasses,
  cls,
  cn,
  resolveElement,
  splitBreakpointProps,
} from "@/lib/utils";
import type { TypographyH2Props } from "../types";

function TypographyH2({ as, asChild, className, ...props }: TypographyH2Props) {
  const Component = resolveElement(asChild, as, "h1");
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && as && asChild) {
    console.warn(
      `[Typography.H2] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }

  return (
    <Component
      className={cn(
        cls`
          scroll-m-20
          ~text-2xl/4xl
          leading-tight lg:leading-[1.3]
          font-header font-semibold
          tracking-tight
        `,
        className,
        classes,
      )}
      {...native}
    />
  );
}

export default TypographyH2;
